import { Box, Image, Stack, useColorMode } from '@chakra-ui/react';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../providers/authContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { googleClientId } from '../conf';
import { BikletaLogoComplete, loginSlidesImages } from '../assets';
import { useSlideshow } from '../utils/useSlideshow';
import './auth-slides.css';

function AuthLayout() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();

  const { setColorMode } = useColorMode();

  /*
   * La foto del costado va rotando entre las tres slides.
   *
   * Las tres se montan superpuestas y lo que cambia es la opacidad: así el cruce es un
   * fundido y no un salto, y las tres quedan decodificadas desde el primer render (no hay
   * parpadeo la primera vez que aparece cada una, como pasaría cambiando el `src`).
   */
  const slide = useSlideshow(loginSlidesImages.length);

  useEffect(() => {
    document.body.style.overflow = 'unset';
    return function cleanup() {};
  });

  /*
   * El modo oscuro se fija una sola vez, al montar.
   *
   * Estaba como llamada suelta en el cuerpo del render, o sea en *cada* render. Cada
   * cambio de color mode hace que Chakra inyecte un `<style>` global con
   * `* { transition: none !important }` —para que el cambio de tema no se vea animado— y
   * lo saque dos frames después (`preventTransition`, en `@chakra-ui/color-mode`). Al
   * dispararse sin parar, ese estilo estaba siempre puesto y ninguna transición CSS de
   * esta pantalla llegaba a correr: el fundido de las fotos cambiaba de golpe.
   */
  useEffect(() => {
    setColorMode('dark');

    return () => {
      setColorMode('light');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (authContext.authState.status === 'logged') {
      navigate('/admin');
    }
  }, [authContext.authState.status, navigate]);

  return (
    <GoogleOAuthProvider clientId={googleClientId}>
      <Stack
        h="100vh"
        position="relative"
        bgColor={'#313149'}
        fontFamily={'Nunito'}
        direction={{ sm: 'column', lg: 'row' }}
        spacing={0}>
        <Box w={{ sm: 'full', lg: '57%' }} h="full">
          <Outlet />
        </Box>
        <Box
          flexGrow={1}
          display={{ base: 'none', lg: 'block' }}
          overflow="hidden"
          pos={'relative'}>
          <div className="auth-slides">
            {loginSlidesImages.map((image, index) => (
              <img
                key={index}
                className={`auth-slide${index === slide ? ' auth-slide--on' : ''}`}
                src={image}
                alt=""
                aria-hidden="true"
              />
            ))}
            {/*
              El viñeteado va en su propia capa: como `inset` se dibuja debajo de los
              hijos del elemento, dejarlo en el contenedor lo tapaban las fotos.
            */}
            <span className="auth-slides__vignette" />
          </div>
          {/* <Box
            pos={'absolute'}
            bottom={4}
            right={0}
            bgColor={'brand.50'}
            p={4}
            pr={'10%'}
            borderLeftRadius={50}>
            <Image src={BikletaLogoComplete.dark} h="2.2rem" color={'black'} alt='Auth Side Image' />
          </Box> */}
        </Box>
      </Stack>
    </GoogleOAuthProvider>
  );
}
export default AuthLayout;
